var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"g-pay"},[_c('div',{attrs:{"id":"g-pay-button-wrap"}}),_c('input',{attrs:{"type":"hidden","name":"gpay_data","value":"","id":"gpay_data"}})])
}]

export { render, staticRenderFns }